module.exports = __webpack_public_path__ + "img/platipus.e9941898.svg";